<template lang="pug">
  nav.b-menu-left(:class="{ opened }")
    ul._list.list-reset
      li._item(
      v-for="item in items"
      :key="item.label"
      )
        router-link._link(:to="{ name: item.route }" :class="item.route")
          Icon(:name="item.icon" pointer colored)
          | {{ item.label }}
          ._new(v-if="item.isNew") new
          ._count(v-if="item.count() > 0") {{ item.count() }}
</template>

<script>
import { isVisitedEnough } from '@/utils/newPage';

export default {
  name: 'MenuLeft',
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [
        /* eslint-disable no-multi-spaces */
        { label: 'Главная',     icon: 'home',           route: 'home',                count: () => 0                              },
        { label: 'Проекты',     icon: 'project',        route: 'project-list',        count: () => this.projectNotificationCount  },
        { label: 'Тарифы',      icon: 'tariffs',        route: 'tariffs',             count: () => 0                              },
        { label: 'Контакты',    icon: 'members',        route: 'contacts',            count: () => this.contactRequestQty         },
        { label: 'Аккаунт',     icon: 'account',        route: 'account',             count: () => 0                              },
        { label: 'уведомления', icon: 'notifications2', route: 'notifications',       count: () => 0                              },
        { label: 'Диаграмма',   icon: 'gantt',          route: 'gantt',               count: () => 0                              },
        { label: 'Задачи',      icon: 'tasks',          route: 'my-task-list',        count: () => 0                              },
        { label: 'Компании',    icon: 'companies',      route: 'company-list',        count: () => this.companyNotificationCount, isNew: !isVisitedEnough('companyListPage'), },
        // { label: 'Календарь',   icon: 'calendar',       route: 'calendar'       },
        /* eslint-enable */
      ],
    };
  },
  computed: {
    self() { return this.$store.state.auth.user; },
    contactRequestQty() {
      return this.$store.state.contact.items
        .filter(c => c.isRequest && this.self.id === c.acceptor.id).length;
    },
    projectNotificationCount() {
      return this.$store.getters['notification/projectRelatedCount'];
    },
    companyNotificationCount() {
      return this.$store.getters['notification/companyRelatedCount'];
    },
  },
};
</script>

<style scoped lang="scss">
@import "../assets/styles/helpers/functions";
.menu-left {
  position: absolute;
  top: calc(10vh - 50px);
  left: calc(18vw - 300px);
  color: var(--color-violent-gray);
  &__list {
    display: grid;
    gap: 8px;
    grid-template-columns: 1fr; //repeat(2, 1fr);
  }
  &__link {
    display: flex;
    //flex-direction: column;
    align-items: center;
    text-transform: uppercase;
    border-radius: 6px;
    font-size: 11px;
    padding: 10px 14px;
    transition: background-color 0.3s, color 0.3s;
    position: relative;
    gap: 10px;
    svg {
      display: block;
      width: 20px;
      height: 20px;
      //margin-bottom: 10px;
      fill: var(--color-violent-gray);
      transition: fill 0.3s;
    }
    &:hover {
      color: var(--color-white);
      background-color: var(--color-accent);
      svg {
        fill: var(--color-white);
      }
    }
    &.router-link-exact-active.home, &.router-link-active:not(.home) {
      color: var(--color-white) !important;
      background-color: var(--color-accent);
      svg {
        fill: var(--color-white);
      }
    }
  }

  &__count {
    position: absolute;
    font-size: 12px;
    line-height: 15px;
    color: #FFFFFF;
    background: #F17275;
    min-width: 7px;
    border-radius: 12px;
    padding: 0 4px;
    bottom: 7px;
    //translate: 0 -50%;
    left: 10px;
    text-align: center;
    //margin-top: -10px;
  }

  &__new {
    color: #fff;
    font-size: 12px;
    background: #4DD861;
    border-radius: 4px;
    padding: 0 4px;
    height: 16px;
    display: flex;
    align-items: center;
  }

  @media (max-width: 1700px) {
    position: relative;
    grid-column: 2 span;
    left: 0;
    top: 30px;
    &__list {
      grid-template-columns: 1fr;
      //gap: 16px;
    }
    &__link {
      //padding: 25px;
      font-size: 10px;
      svg {
        //width: 29px;
        //height: 29px;
      }
    }
  }

  @media (max-width: 1500px) {
    top: 0;
    padding: 30px 0 64px;
    grid-column: auto;

    &__list {
      grid-template-columns: 1fr;
      //gap: 16px;
    }

    &__link {
      //padding: 14px 5px;
      font-size: 9px;
    }
  }

  @media (max-width: 1024px) {
    display: none;
    //place-items: center;
    position: absolute;
    top: 0;
    left: 0;
    overflow: auto;
    width: 75vw;
    max-width: 300px;
    height: 100vh;
    z-index: 1100;
    background-color: #F8F9FC;
    padding: 0;
    transform: translateX(-100%);
    transition: transform 0.4s;
    &__list {
      padding: 30px;
      align-items: stretch;
      display: flex;
      flex-direction: column;
      width: 100%;
      justify-content: flex-start;
      box-sizing: border-box;
      //max-width: 200px;
      //grid-template-columns: repeat(2, 1fr);
      //gap: 50px;
    }
    &__link {
      justify-content: start;
      //padding: 19px 14px;
      //font-size: 16px;
    }
    &.opened {
      transform: translateX(0);
      display:grid;
    }
    &-close {
      display: block;
    }
  }
}
@media (max-width: 768px) {

}
</style>
